module.exports = __webpack_public_path__ + "img/database.72eb2c49.svg";